<ng-container *ngIf="widgetVisible && !!chartView">
    <!--Widget source id is embedded for PDF exporting algorithm (backend) to be able to localize this container inside the document.-->
    <!--If view is PDF preview, an extra class is applied to change the styles of the view correspondingly.-->
    <div [id]="widgetSourceId"
         [class]="widgetContainerClass"
         [ngClass]="{'pdf-view': output === 'PDF'}">

        <div class="widget-chart-topbar">
            <h2 *ngIf="!!widgetTitle?.length">{{ widgetTitle }}</h2>

            <!--This element is visible in web view only.-->
            <p-button *ngIf="exportable && output === 'web'"
                      styleClass="p-button-lg p-button-outlined p-button-text p-button-icon-only"
                      class="exporting-button" icon="pi pi-file-pdf" title="Export to PDF"
                      [loading]="pdfExportingLoading | async" (onClick)="generatePdf()">
            </p-button>
        </div>

        <div [class]="chartGraphClass">
            <!--Web view of the widget chart. This element is visible in web view only.-->
            <p-chart *ngIf="!!chartSettings && output === 'web'"
                     [data]="chartData ?? []"
                     [type]="chartSettings.type"
                     [width]="chartSettings.width"
                     [height]="chartSettings.height"
                     [options]="chartSettings.options"
                     [plugins]="chartSettings.plugins"></p-chart>

            <!--PDF view of the widget chart. This element is visible in PDF view only.-->
            <!--It can be rendered hidden by demand, by setting renderPdfViewHidden to true.-->
            <p-chart #pdfViewChart *ngIf="!!chartSettings && (renderPdfViewHidden || output === 'PDF')"
                     [ngClass]="{'pdf-view-hidden' : renderPdfViewHidden}"
                     [data]="chartData ?? []"
                     [type]="chartSettings.type"
                     [width]="pdfViewChartWidth"
                     [height]="pdfViewChartHeight"
                     [options]="chartSettings.options"
                     [plugins]="chartSettings.plugins"></p-chart>
        </div>

        <!--This element is visible in web view only.-->
        <div *ngIf="chartDatasets?.length > 10" class="widget-chart-dataset-link">
            <label>
                Currently chart shows a reduced number of data sets.
                <a (click)="showDatasetManager()"> Manage datasets</a>
            </label>
        </div>
    </div>
</ng-container>

<p-dialog [(visible)]="datasetManagerVisible"
          [modal]="true" [resizable]="false"
          (onHide)="hideDatasetManager()"
          styleClass="widget-chart-dataset-manager"
          header="Datasets">

    <ng-template pTemplate="content">
        <p-multiSelect [(ngModel)]="selectedDatasets"
                       [options]="chartDatasets"
                       dataKey="label"
                       appendTo="body">
        </p-multiSelect>
    </ng-template>

    <ng-template pTemplate="footer">
        <p-footer>
            <p-button label="Accept" (onClick)="changeDatasetsVisibility()"></p-button>
            <p-button label="Cancel" (onClick)="hideDatasetManager()"></p-button>
        </p-footer>
    </ng-template>

</p-dialog>